export default __webpack_public_path__ + "static/media/IC00027-info_org.0b225149.svg";